import { Component } from '@angular/core';
import { IonicPage,Events, NavController, NavParams, ModalController, ActionSheetController,AlertController,ViewController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';

/**
 * Generated class for the SetupModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-setup-modal',
  templateUrl: 'setup-modal.html',
})
export class SetupModalPage {
    profile: any = {
       name:'',
       email:'',
       phone:'',
       muncipality:'',
       businessName:'',
       reason:'',
       businessState: 'VICTORIA',
       businessCountry: 'AUSTRALIA'
      };

   
    businessData = {
      "businessCategories": [
        "AGRICULTURE, FORESTRY AND FISHING",
        "MINING",
        "MANUFACTURING",
        "ELECTRICITY, GAS, WATER AND WASTE SERVICES",
        "CONSTRUCTION",
        "WHOLESALE TRADE",
        "RETAIL TRADE",
        "ACCOMMODATION AND FOOD SERVICES",
        "TRANSPORT, POSTAL AND WAREHOUSING",
        "INFORMATION MEDIA AND TELECOMMUNICATIONS",
        "FINANCIAL AND INSURANCE SERVICES",
        "RENTAL, HIRING AND REAL ESTATE SERVICES",
        "PROFESSIONAL, SCIENTIFIC AND TECHNICAL SERVICES",
        "ADMINISTRATIVE AND SUPPORT SERVICES",
        "PUBLIC ADMINISTRATION AND SAFETY",
        "EDUCATION AND TRAINING",
        "HEALTH CARE AND SOCIAL ASSISTANCE",
        "ARTS AND RECREATION SERVICES",
        "OTHER SERVICES"
      ],
      "businessTypes": {
        "AGRICULTURE, FORESTRY AND FISHING": [
          "Nursery and Floriculture Production",
          "Mushroom and Vegetable Growing",
          "Fruit and Tree Nut Growing",
          "Aquaculture",
          "Agriculture, Forestry and Fishing Support Services",
        ],
        "MINING": [
          "Exploration and Other Mining Support Services",
        ],
        "MANUFACTURING": [
          "Food Product Manufacturing",
          "Beverage and Tobacco Product Manufacturing",
          "Textile, Leather, Clothing and Footwear Manufacturing",
          "Wood Product Manufacturing",
          "Pulp, Paper and Converted Paper Product Manufacturing",
          "Printing (including the Reproduction of Recorded Media)",
          "Petroleum and Coal Product Manufacturing",
          "Basic Chemical and Chemical Product Manufacturing",
          "Polymer Product and Rubber Product Manufacturing",
          "Non-Metallic Mineral Product Manufacturing",
          "Primary Metal and Metal Product Manufacturing",
          "Fabricated Metal Product Manufacturing",
          "Transport Equipment Manufacturing",
          "Machinery and Equipment Manufacturing",
          "Furniture and Other Manufacturing",
        ],
        "ELECTRICITY, GAS, WATER AND WASTE SERVICES": [
          "Electricity Supply",
          "Gas Supply",
          "Water Supply, Sewerage and Drainage Services",
          "Waste Collection, Treatment and Disposal Services"
        ],
        "CONSTRUCTION": [
          "Building Construction",
          "Heavy and Civil Engineering Construction",
          "Construction Services",
          "Land Development and Subdivision",
          "Site Preparation Services",
          "Building Structure Services, nfd",
          "Concreting Services",
          "Bricklaying Services",
          "Roofing Services",
          "Structural Steel Erection Services",
          "Plumbing Services",
          "Electrical Services",
          "Air Conditioning and Heating Services",
          "Fire and Security Alarm Installation Services",
          "Other Building Installation Services",
        ],
        "WHOLESALE TRADE": [
          "Basic Material Wholesaling",
          "Machinery and Equipment Wholesaling",
          "Motor Vehicle and Motor Vehicle Parts Wholesaling",
          "Grocery, Liquor and Tobacco Product Wholesaling",
          "Other Goods Wholesaling",
        ],
        "RETAIL TRADE": [
          "Motor Vehicle and Motor Vehicle Parts Retailing",
          "Fuel Retailing",
          "Food Retailing",
          "Furniture, Floor Coverings, Houseware and Textile Goods Retailing",
          "Electrical and Electronic Goods Retailing",
          "Hardware, Building and Garden Supplies Retailing",
          "Recreational Goods Retailing",
          "Clothing, Footwear and Personal Accessory Retailing",
          "Department Stores",
          "Pharmaceutical and Other Store-Based Retailing",
        ],
        "ACCOMMODATION AND FOOD SERVICES": [
          "Accommodation",
          "Cafes, Restaurants and Takeaway Food Services, nfd",
          "Cafes and Restaurants",
          "Takeaway Food Services",
          "Catering Services",
          "Pubs, Taverns and Bars",
          "Clubs (Hospitality)",
        ],
        "TRANSPORT, POSTAL AND WAREHOUSING": [
          "Road Transport",
          "Rail Transport",
          "Water Transport",
          "Other Transport",
          "Postal and Courier Pick-up and Delivery Services",
          "Transport Support Services",
          "Warehousing and Storage Services",
        ],
        "INFORMATION MEDIA AND TELECOMMUNICATIONS": [
          "Publishing (except Internet and Music Publishing)",
          "Motion Picture and Sound Recording Activities",
          "Broadcasting (except Internet)",
          "Internet Publishing and Broadcasting",
          "Telecommunications Services",
          "Internet Service Providers, Web Search Portals and Data Processing Services",
          "Library and Other Information Services",
        ],
        "FINANCIAL AND INSURANCE SERVICES": [
          "Insurance and Superannuation Funds"
        ],
        "RENTAL, HIRING AND REAL ESTATE SERVICES": [
          "Rental and Hiring Services (except Real Estate)",
          "Property Operators and Real Estate Services"
        ],
        "PROFESSIONAL, SCIENTIFIC AND TECHNICAL SERVICES": [
          "Computer System Design and Related Services",
          "Scientific Research Services",
          "Architectural, Engineering and Technical Services",
          "Legal and Accounting Services",
          "Advertising Services",
          "Market Research and Statistical Services",
          "Management and Related Consulting Services",
          "Veterinary Services",
          "Other Professional, Scientific and Technical Services",
        ],
        "ADMINISTRATIVE AND SUPPORT SERVICES": [
          "Employment Services",
          "Travel Agency and Tour Arrangement Services",
          "Office Administrative Services",
          "Document Preparation Services",
          "Credit Reporting and Debt Collection Services",
          "Call Centre Operation",
          "Building Cleaning, Pest Control and Gardening Services, nfd",
          "Building and Other Industrial Cleaning Services",
          "Building Pest Control Services",
          "Gardening Services",
          "Packaging Services",
        ],
        "PUBLIC ADMINISTRATION AND SAFETY": [
          "Public Administration",
          "Defence",
          "Public Order, Safety and Regulatory Services",
        ],
        "EDUCATION AND TRAINING": [
          "Preschool and School Education",
          "Tertiary Education",
          "Adult, Community and Other Education",
        ],
        "HEALTH CARE AND SOCIAL ASSISTANCE": [
          "Hospitals",
          "Medical Services",
          "Pathology and Diagnostic Imaging Services",
          "Allied Health Services",
          "Other Health Care Services",
          "Residential Care Services",
          "Social Assistance Services (including Child Care Services)",
        ],
        "ARTS AND RECREATION SERVICES": [
          "Heritage Activities (including museums and parks and gardens)",
          "Creative and Performing Arts Activities",
          "Sports and Recreation Activities",
          "Gambling Activities",
        ],
        "OTHER SERVICES": [
          "Automotive Repair and Maintenance",
          "Machinery and Equipment Repair and Maintenance",
          "Other Repair and Maintenance (including clothing and footwear)",
          "Hairdressing and Beauty Services",
          "Diet and Weight Reduction Centre Operation",
          "Funeral, Crematorium and Cemetery Services",
          "Laundry and Dry-Cleaning Services",
          "Photographic Film Processing",
          "Parking Services",
          "Brothel Keeping and Prostitution Services",
          "Other Personal Services nec",
          "Religious Services",
          "Business and Professional Association Services",
          "Labour Association Services",
          "Other Interest Group Services nec",
        ]
      }
    }    
  

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewController:ViewController,public modalCtrl: ModalController,  public events:Events,public data:DataProvider, public alertCtrl:AlertController) {
  }

  ngOnInit() {

  }

  assessment: any = [
    {reason: 'To reduce carbon emissions & waste'},
    {reason: 'To save money'},
    {reason: 'To find simple & low cost actions'}
  ]

  ionViewDidLoad() {
  
    console.log('ionViewDidLoad SetupModalPage');
  }

     ionViewWillEnter(){

     setTimeout(() => {
         console.log("data");
         console.log(this.data.user);
         if(this.data.user){
          // this.profile = this.data.user;
          this.profile = { ...this.profile, ...this.data.user }
         }
         
    },1000);
    //  this.intializeSubscriptions();
      
  }

  async dismiss(){

    if(!this.profile.businessStreetType){
      this.profile.businessStreetType = '';
    }
    if(this.profile.businessStreetNumber && this.profile.businessStreetName && this.profile.businessSuburb && this.profile.businessPostcode && this.profile.businessState && this.profile.businessCountry && this.profile.businessTypeLevel1 && this.profile.businessTypeLevel2 && this.profile.reason){
      this.data.updateUserDoc({businessStreetNumber:this.profile.businessStreetNumber, businessStreetName:this.profile.businessStreetName, businessStreetType:this.profile.businessStreetType, businessSuburb:this.profile.businessSuburb, businessPostcode:this.profile.businessPostcode, businessState:this.profile.businessState, businessCountry:this.profile.businessCountry, businessTypeLevel1: this.profile.businessTypeLevel1, businessTypeLevel2: this.profile.businessTypeLevel2,reason:this.profile.reason});
      this.viewController.dismiss();
    }else {
      await this.showAlert();
    }
  }

  async showAlert() {
    const alert = await this.alertCtrl.create({
      title: 'Alert',
      subTitle: 'Please fill out all required fields.',
      cssClass: 'action-alert',
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            // console.log('Ok');
          }
        }
      ]
    });

    await alert.present();
  }

}


// WEBPACK FOOTER //
// ./src/pages/setup-modal/setup-modal.ts